<template>
  <!-- Conditional Rendering of Document List-->
  <b-overlay :show="status.showSpinner" rounded="sm">
    <b-card
      title="Documents"
      style="
        overflow-y: auto;
        min-height: 250px;
        max-height: 85vh;
        width: 100%;
        display: block;
      "
      class="shadow bg-white"
    >
      <b-card-group deck>
        <b-card
          class="my-2"
          v-for="(document, id) in documents"
          :key="id"
          style="min-width: 250px"
        >
          <p class="card-text" style="height: 300px; overflow: hidden">
            <span v-for="(token, id) in document.text_parsed" :key="id">
              <span v-if="token.is_entity">
                <span v-if="token.ent_iob === 'B'">
                  <span
                    class="badge badge-secondary"
                    :style="{
                      'background-color': entityColorScale(token.entity_type),
                    }"
                  >
                    {{ token.entity_type }}:
                  </span>
                  {{ token.text }}
                  <span> </span>
                </span>
                <span v-else>
                  {{ token.text }}
                  <span> </span>
                </span>
              </span>
              <span v-else class="text-muted">{{ token.text }} </span>
            </span>
          </p>
          <div slot="footer">
            <b-link variant="primary" v-on:click="openModalAnnotate(id)" block
              >Open</b-link
            >
            <span class="text-muted"> - {{ document._id["$oid"] }}</span>
          </div>
        </b-card>
      </b-card-group>

      <b-pagination
        v-if="pagination.documents > pagination.perPage"
        align="center"
        v-model="pagination.currentPage"
        :total-rows="pagination.documents"
        :per-page="pagination.perPage"
      ></b-pagination>

      <!-- Modals -->
      <b-modal
        id="modal-annotate"
        ref="modal-annotate"
        title=""
        size="xl"
        scrollable
        no-fade
        :hide-footer="true"
      >
        <b-container
          ref="modalAnnotateText"
          style="min-height: 500px"
          class="my-4"
        >
          <b-row align-h="center">
            <b-col cols="11">
              <span
                v-for="(token, id) in modals.annotate.text.slice(
                  0,
                  modals.annotate.tokensShown
                )"
                :key="id"
                style="margin-right: 3px"
              >
                <!-- Entity -->
                <span
                  v-if="token.is_entity"
                  v-bind:id="'token-' + token.s_id + '-' + token.t_id"
                >
                  <span v-if="token.ent_iob === 'B'">
                    <!-- Set badge color dynamicly -->
                    <span
                      class="badge badge-primary"
                      :style="{
                        'background-color': entityColorScale(token.entity_type),
                      }"
                    >
                      {{ token.entity_type }}:
                    </span>
                    {{ token.text }}
                  </span>
                  <span v-else>
                    {{ token.text }}
                  </span>
                </span>

                <!-- no Entity -->
                <span
                  v-else
                  v-bind:id="'token-' + token.s_id + '-' + token.t_id"
                  class="text-muted"
                  >{{ token.text }}
                </span>
              </span>

              <span
                v-show="
                  modals.annotate.tokensShown < modals.annotate.text.length
                "
              >
                ...</span
              >
            </b-col>
          </b-row>
          <b-row
            align-h="center"
            v-show="modals.annotate.tokensShown < modals.annotate.text.length"
          >
            <b-col sm="auto">
              <b-button
                size="sm"
                class="my-4"
                @click="
                  modals.annotate.tokensShown =
                    modals.annotate.tokensShown + 1000
                "
                >load more</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
    </b-card>
  </b-overlay>
</template>

<script>
import pagination from "./shared/pagination.vue";
import requestsMixin from "../mixins/requestsMixin";
import constantsMixin from "../mixins/constantsMixin";

export default {
  name: "component-list-documents",
  components: { pagination },
  mixins: [requestsMixin, constantsMixin],
  props: {
    corpus_id: { type: String },
    documentIds: { type: Array },
  },
  data() {
    return {
      documents: [],

      // Variables used to controle
      // pagination element
      pagination: {
        currentPage: 1,
        documents: 0,
        perPage: 6,
      },

      // Variables needed for
      // modals used to
      // annotate documents
      modals: {
        annotate: {
          text: "",
          localId: -1,
          documentId: "",
          tokensShown: 1000,
        },
      },

      // Variables used for tracking
      // the state of the component
      status: {
        showSpinner: false,
      },
    };
  },
  methods: {
    /* ------------------------- View Annotated Document ------------------------ */

    // Show modal for annotating text of a document
    // and store index, document_id and the text
    // in temp variables as long as modal open
    openModalAnnotate(id) {
      this.modals.annotate.localId = id;
      this.modals.annotate.documentId = this.documents[id]["_id"]["$oid"];
      this.modals.annotate.text = this.documents[id]["text_parsed"];
      this.$refs["modal-annotate"].show();
      this.modals.annotate.tokensShown = 1000;
    },

    /* -------------------------- Refresh Document List ------------------------- */
    // Fetch document subset according to the selected page.

    updateDocumentList(corpus_id) {
      if (!!corpus_id) {
        // Start spinner
        new Promise((resolve) => {
          this.status.showSpinner = true; // Show spinner
          resolve(true);
        })
          // Fetch meta information about corpus
          .then(() => {
            if (this.documentIds.length > 0) {
              this.pagination.documents = [...new Set(this.documentIds)].length; // count of selected documents
            } else {
              this.fetchCorpusMetaData(corpus_id).then((result_data) => {
                // count of all documents
                this.pagination.documents = result_data;
              });
            }
          })
          // Fetch documents in corpus
          .then(() => {
            return this.fetchDocumentsById(
              corpus_id,
              this.documentIds,
              this.pagination.currentPage,
              this.pagination.perPage
            );
          })
          .then((response) => {
            this.documents = response;
          })
          // Stop spinner
          .finally(() => {
            this.status.showSpinner = false; // Hide spinner
          })
          // Shwow error message
          .catch((error) => {
            console.log(error);
            this.showToast(
              String(error.message),
              String(error.cause),
              "danger"
            );
          });
      }
    },
  },
  watch: {
    corpus_id(value) {
      this.updateDocumentList(value);
    },
    documentIds(value) {
      this.updateDocumentList(this.corpus_id);
    },
    "pagination.currentPage"(value) {
      this.updateDocumentList(this.corpus_id);
    },
  },
  mounted() {
    this.updateDocumentList(this.corpus_id);
  },
};
</script>

<style scoped>
#popover-reparse-content {
  min-width: 350px;
}
</style>


// WEBPACK FOOTER //
// src/components/listDocuments.vue